import { render, staticRenderFns } from "./organizationPOActive.vue?vue&type=template&id=578aac2d&"
import script from "./organizationPOActive.vue?vue&type=script&lang=js&"
export * from "./organizationPOActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports